export default __webpack_public_path__ + "assets/images/google_on_white_hdpi.68f88d8214a1686a936526a82f99320d.png";